import { render, staticRenderFns } from "./RTI.vue?vue&type=template&id=4012e1fe&scoped=true&"
import script from "./RTI.vue?vue&type=script&lang=js&"
export * from "./RTI.vue?vue&type=script&lang=js&"
import style0 from "./RTI.vue?vue&type=style&index=0&id=4012e1fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4012e1fe",
  null
  
)

export default component.exports